import React from 'react';

import WarnIcon from 'common/components/dialog-function/WarnIcon';
import { Col, Row, Space, Table, Typography } from 'antd';
import {
  CustomNotification,
  FormCancelButton,
  FormSaveButton,
  StyledModal,
} from 'common/components';
import { formatMDY } from 'utils/formatDate';
import {
  useMutateProcessOutstandingBilling,
  useQueryOutstandingBilling,
} from 'pages/check-credit-card-info/queries';
import { useGetMemberId } from 'hooks';

import './OutstandingBillingModal.less';
import { useRefetchAllMemberBillingStatement } from '../queries';

const COLUMNS_TABLE = [
  {
    title: 'Type',
    dataIndex: 'billingType',
    width: 140,
  },
  {
    title: 'Description',
    dataIndex: 'description',
    ellipsis: true,
    width: 250,
  },
  {
    title: 'Date',
    dataIndex: 'dateChargeOccurred',
    render: (date, _) => formatMDY(date),
  },
  {
    title: 'Amount',
    dataIndex: 'amount',
  },
  {
    title: 'Balance',
    dataIndex: 'balance',
  },
  {
    title: 'Status',
    dataIndex: 'status',
  },
];

const OutstandingBillingModal = ({ visible, setVisible }) => {
  const { memberId } = useGetMemberId();
  const { outstandingBilling, invalidateOutstandingBilling } =
    useQueryOutstandingBilling({ memberId });

  const outstandingStatements = outstandingBilling?.outstandingStatements || [];

  const processOutstandingBilling = useMutateProcessOutstandingBilling();

  const refetchAllMemberBillingStatement =
    useRefetchAllMemberBillingStatement();

  const onSubmit = () => {
    const billingStatementIds = outstandingStatements?.map(
      (item) => item?.billingStatementId
    );

    const params = {
      memberId,
      billingStatementIds: billingStatementIds || [],
    };

    processOutstandingBilling.mutate(params, {
      onSuccess: (result) => {
        if (result?.isSuccess) {
          setVisible(false);
          refetchAllMemberBillingStatement();
          invalidateOutstandingBilling();
          CustomNotification.success('Account has been brought current');
        } else {
          CustomNotification.error(result?.message || 'Server Error');
        }
      },
      onError: (error) => {
        CustomNotification.error(error?.message || 'Server Error');
      },
    });
  };

  return (
    <StyledModal
      className='outstanding-billing-modal'
      title={null}
      width={800}
      bodyStyle={{ paddingTop: 24, paddingBottom: 4 }}
      visible={visible}
      masClosable={false}
      onCancel={() => setVisible(false)}
      footer={[
        <Row justify='end'>
          <Col>
            <Space>
              <FormSaveButton
                text='Continue'
                onClick={onSubmit}
                loading={processOutstandingBilling.isLoading}
              />
              <FormCancelButton onClick={() => setVisible(false)} />
            </Space>
          </Col>
        </Row>,
      ]}
    >
      <WarnIcon />
      <div
        style={{
          color: '#6c757d',
          fontSize: 16,
          textAlign: 'left',
          marginTop: 4,
        }}
      >
        <Row style={{ padding: '10px 0' }}>
          <Col style={{ marginBottom: 8, textAlign: 'center', width: '100%' }}>
            <Typography.Paragraph>
              The below transactions are currently outstanding:
            </Typography.Paragraph>
          </Col>
          <div style={{ width: '100%' }}>
            <Table
              columns={COLUMNS_TABLE}
              dataSource={outstandingStatements}
              pagination={false}
              scroll={{ y: 150 }}
            />
          </div>
          <Col style={{ marginTop: 8, textAlign: 'center', width: '100%' }}>
            <Typography.Paragraph style={{ marginBottom: 0 }}>
              Please click <strong>[Continue]</strong> below to bring your
              account current
            </Typography.Paragraph>
          </Col>
        </Row>
      </div>
    </StyledModal>
  );
};

export default OutstandingBillingModal;
